module.exports = __webpack_public_path__ + "static/man-leaning-on-railing-mobile.302c0738.webp";